import React from "react";

import { RideGlPillSolid } from "@rimac-seguros/ride-system-components";

export const ContentCuidafarma = () => {
  return (
    <section className="banner-benefits">
      <div className="banner-benefits_card">
        <span>Cuidafarma</span>
      </div>
      <RideGlPillSolid
        size="x-large"
        fill="var(--ride-sys-color-surface-default)"
        className="hidden lg:block"
      />
      <p>
        Aprovecha nuestros beneficios para ahorrar y estar protegido
      </p>
      <RideGlPillSolid
        size="x-large"
        fill="var(--ride-sys-color-surface-default)"
        className="hidden lg:block"
      />
      <div className="hidden banner-benefits_card lg:flex">
        <span>Cuidafarma</span>
      </div>
    </section>
  );
};
